import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  text: 'Me sorprendió lo claro y organizado que está todo el contenido. Sentí que realmente pude comprender conceptos que antes veía muy complejos.',
  name: 'Carolina M.',
  city: 'Ciudad de México, México'
}, {
  text: 'Lo empecé por interés personal y terminé incorporando herramientas muy útiles para aplicar todos los días.',
  name: 'Valeria S.',
  city: 'Bogotá, Colombia'
}, {
  text: 'La estructura, los protocolos y los casos reales hacen que se sienta una formación muy profesional.',
  name: 'Ana P.',
  city: 'Santiago, Chile'
}, {
  text: 'Apliqué el método con mis primeros clientes y los resultados fueron inmediatos. La formación me dio una seguridad que no esperaba.',
  name: 'Daniela T.',
  city: 'Lima, Perú'
}, {
  text: 'Buscaba algo serio y completo, y esto superó mis expectativas. Hoy tengo herramientas reales para acompañar procesos de sanación.',
  name: 'Mariana R.',
  city: 'Montevideo, Uruguay'
}];
function TestimonialCard({
  text,
  name,
  city,
  index
}: {
  text: string;
  name: string;
  city: string;
  index: number;
}) {
  const [ref, vis] = useReveal();
  return <div ref={ref} className={`reveal bg-[#ffffff] border border-[#2E4F48]/10 rounded-2xl p-6 flex flex-col gap-3 transition-all duration-500 hover:border-[#44574F]/30 hover:shadow-md ${vis ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-325">
      <div className="flex gap-0.5" data-id="element-326">
        {Array.from({
        length: 5
      }).map((_, i) => <span key={i} className="text-[#C2683D] text-sm" data-id="element-327">
            ★
          </span>)}
      </div>
      <p className="text-[#44574F] text-sm md:text-base leading-relaxed italic flex-grow" data-id="element-328">
        "{text}"
      </p>
      <div className="flex items-center gap-3 pt-3 border-t border-[#2E4F48]/10" data-id="element-329">
        <div className="w-9 h-9 rounded-full bg-[#44574F]/15 border border-[#44574F]/25 flex items-center justify-center flex-shrink-0" data-id="element-330">
          <span className="text-[#2E4F48] font-bold text-xs" data-id="element-331">
            {name.split(' ').map(n => n[0]).join('')}
          </span>
        </div>
        <div data-id="element-332">
          <p className="text-[#1C3B36] text-sm font-bold leading-tight" data-id="element-333">
            {name}
          </p>
          <p className="text-[#44574F] text-xs" data-id="element-334">{city}</p>
        </div>
      </div>
    </div>;
}
export function TestimonialsSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#E8E0D3] py-5 md:py-10 px-4 sm:px-6 border-t border-[#2E4F48]/5" data-id="element-335">
      <div className="container mx-auto max-w-5xl" data-id="element-336">
        <div ref={ref} className={`reveal text-center mb-8 ${vis ? 'is-visible' : ''}`} data-id="element-337">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1C3B36]" data-id="element-338">
            Experiencias de alumnos
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-339">
          {TESTIMONIALS.map((t, i) => <TestimonialCard key={i} {...t} index={i} data-id="element-340" />)}
        </div>
      </div>
    </section>;
}